import process from 'process'

const EncodeDecode = {
  
  base64Encode: (string) => {
    if (process.browser) {
      return btoa(string);
    } else {
      return Buffer.from(string, 'binary').toString('base64');
    }
  },

  base64Decode: (b64String) => {
    if (process.browser) {
      return atob(b64String);
    } else {
      return Buffer.from(b64String, 'base64').toString();
    }
  }

};

export default EncodeDecode;


